var XPortal = XPortal || {};
XPortal.ToolTips = (function () {
    var self = {
        ControlsToExcept: ["data-xcalendar-picker", "data-xcalendar-picker-readonly"],
        Init: function (container, opts) {
            if (self.ControlsToExcept.some(c => $(container).hasClass(c)))
                return;

            container = container ? container : $(XPortal.Main.DetialFormSelector);
            const toolTip = container.kendoTooltip(opts).data("kendoTooltip");
            var toolTips = container.find("a.tooltip");
            toolTips.click(false);
            container.data("xpand-tooltip", toolTip);
            return toolTip;
        },
        InitToolTips: function ($container) {
            const opts = {
                position: 'bottom',
                offset: -10,
                content: function (e) {
                    const $target = $(e.sender.element);
                    const i = $target[0];
                    const $i = $(i);

                    const content = i.value || $i.text();
                    const elementParams = self.GetElementTextWidth(i, content);
                    const computed = getComputedStyle(i);
                    const inputWidth = parseFloat(computed.width) - parseFloat(computed.paddingLeft) - parseFloat(computed.paddingRight);

                    if (!elementParams || !content.length || inputWidth > elementParams.width || elementParams.style.textWrap == "wrap")
                        return;

                    return content;
                },
                show: function (e) {
                    const $target = $(e.sender.element);
                    const i = $target[0];
                    const $i = $(i);

                    const tooltip = $i.data("xpand-tooltip");

                    const content = i?.value || $i.text();
                    const elementParams = self.GetElementTextWidth(i, content);
                    const computed = getComputedStyle(i);
                    const inputWidth = parseFloat(computed.width) - parseFloat(computed.paddingLeft) - parseFloat(computed.paddingRight);

                    if (!elementParams || !content.length || inputWidth > elementParams.width) {
                        tooltip.refresh();
                        return;
                    }

                    const tooltipElement = this.popup.element;
                    const tooltipWidth = $target.outerWidth();
                    const targetOffset = $target.offset();
                    const targetCenterX = targetOffset.left + ($target.outerWidth() / 2);

                    // Set tooltip dimensions and position

                    tooltipElement.parent('.k-animation-container').css({
                        'width': `${tooltipWidth}px`,
                    });

                    tooltipElement.find('.k-tooltip-content').html(content);

                    tooltipElement.addClass('validation-tooltip');
                    tooltipElement.addClass('filter-tooltip');

                    const factTooltipWidth = tooltipElement[0].clientWidth;
                    tooltipElement.parent('.k-animation-container').css({
                        'left': `${targetCenterX - factTooltipWidth + factTooltipWidth / 2}px`,
                    });

                    const $calloutElement = tooltipElement.find('.k-callout');
                    $calloutElement.css('left', `${factTooltipWidth / 2}px`);
                }
            };
            const fields = $($container).find("[data-metadata-fieldname], .xpand-dropdown .k-input").filter(function () {
                const el = $(this);
                return !el.hasClass("xpand-hidden") && el.closest('.d-none').length == 0;
            });
            fields.each(function () {
                const $field = $(this);
                self.Init($field, opts);
            });
        },
        GetElementTextWidth(element, text) {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            const style = getComputedStyle(element);
            ctx.font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;

            return { width: ctx.measureText(text).width + 20, style: style }; // 20 pixels is for possible padding
        }
    };

    return self;
}());
